import React, { useEffect } from 'react';
import GlobalCanvas   from './components/GlobalCanvas';
import Navbar         from './components/Navbar';
import Hero           from './components/Hero';
import About          from './components/About';
import Services       from './components/Services';
import Projects       from './components/Projects';
import Process        from './components/Process';
import Testimonials   from './components/Testimonials';
import CTA            from './components/CTA';
import Contact        from './components/Contact';
import Footer         from './components/Footer';
import Toast          from './components/Toast';

export default function App() {
  /* Global scroll-reveal observer.
     Adds the "visible" class to any element that carries
     .reveal / .reveal-left / .reveal-right when it enters
     the viewport. */
  useEffect(() => {
    const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <>
      {/* Fixed 3D canvas that lives behind every section */}
      <GlobalCanvas />

      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Process />
      <Testimonials />
      <CTA />
      <Contact />
      <Footer />
      <Toast />
    </>
  );
}
